import { onMounted, onUnmounted, watch, type Ref } from 'vue';

type KeyHandlerMap = {
  [key: string]: () => void;
};

export function useKeyPress(
  target: Ref<HTMLElement | null>,
  keyHandlers: KeyHandlerMap,
  shouldListen = true
) {
  const handleKeyDown = (e: KeyboardEvent) => {
    const handler = keyHandlers[e.key];
    if (handler) handler();
  };

  const add = () => target.value?.addEventListener('keydown', handleKeyDown);
  const remove = () =>
    target.value?.removeEventListener('keydown', handleKeyDown);

  onMounted(() => {
    if (shouldListen && target.value) add();
  });

  onUnmounted(remove);

  watch(target, (el, _, onCleanup) => {
    if (shouldListen && el) {
      add();
      onCleanup(remove);
    }
  });
}
